// First import in src/index.tsx: starts the immersive Quest app's WebXR session
// before the rest of the app (three.js, R3F, routes) is even evaluated. A no-op
// everywhere else. See utils/questImmersiveSession.ts.
import { startQuestImmersiveApp } from './questImmersiveSession';

startQuestImmersiveApp();
